export const tinPattern = new RegExp('(^$)|^[0-9]{10}$|^[0-9]{14}$');
export const compareWithTin = (tin: number | string) =>
  new RegExp('^X$'.replace('X', String(tin)));
